import React, {useState, useRef} from 'react';
import classes from './Pregunta.module.css';
import $ from 'jquery';

export const Pregunta = ({data = {}}) => {

    const [isOpen, setIsOpen] = useState(false);
    const [isBusy, setIsBusy] = useState(false);

    const icon = useRef();
    const respContainer = useRef();

    const handleClick = () => {
        if(!isBusy){
            setIsBusy(true);
            if(!isOpen){
                icon.current.style.transform = "rotate(90deg)";
                $(respContainer.current).slideDown(()=>{
                    setIsBusy(false);
                });
                setIsOpen(true);
            }else{
                icon.current.style.transform = "";
                $(respContainer.current).slideUp(()=>{
                    setIsBusy(false);
                });
                setIsOpen(false);
            }
        }
    }

    return(
        <div className={classes.container}>
            <div className={classes.preguntaContainer}>
                <i className="fas fa-chevron-right" ref={icon} onClick={handleClick}></i>
                <span onClick={handleClick}>{data.pregunta}</span>
            </div>
            <div className={classes.hidden} ref={respContainer}>
                {
                    data.respuesta.map((item, index) => (
                        <div key={index} className={classes.respContainer}>
                            {
                                (item.title)&&
                                <span className={classes.title}>{item.title}</span>
                            }
                            <div dangerouslySetInnerHTML={{__html: item.body}}/>
                        </div>
                    ))
                }
            </div>
        </div>
    );
}